import { useState, useEffect } from 'react';
import Content from '../components/Content';
import { useNavigate, useParams } from 'react-router';
import FullForm from '../components/main/book/FullForm';
import MainBookFormStore from '../stores/MainBookFormStore';
import { CircularProgress } from '@material-ui/core';

const MainBookEdit = ({ userStore, snackStore }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const mainBookFormStore = new MainBookFormStore(userStore, snackStore, navigate);

  useEffect(() => {
    mainBookFormStore.loadMainBook(id);
  }, []);

  return (
    <Content title=""  userStore={userStore}>
      {mainBookFormStore.loading && <CircularProgress />}
      <FullForm mainBookFormStore={mainBookFormStore} userStore={userStore} snackStore={snackStore} />
    </Content>
  );
};

export default MainBookEdit;
